import type { SxProps, Theme } from '@mui/material/styles';

import Alert from '@mui/material/Alert';

interface FormErrorAlertProps {
  message?: string | null;
  sx?: SxProps<Theme>;
}

// Renders an inline error banner above a form. Caller resolves the message
// (typically via i18n: `t(`errors.${code}`, { defaultValue: code })`).

export function FormErrorAlert({ message, sx }: FormErrorAlertProps) {
  if (!message) return null;
  return (
    <Alert severity="error" sx={sx}>
      {message}
    </Alert>
  );
}
